export default () => ({
  isActive: false,
  isShow: false,
  isShowPrice: false,
  covenants: [],
  images: [],
  index: null,
  graduations: {},
  professionalProfilePublic: [],
  crm: null,
  uf: null,
  professionalQRCodeURL: null,
  profilePublic: [],
  totalAgendas: 0,
  totalAgendaSchedules: 0,
  totalProfessional: 0,
  operatorCovenant: null,
  noProfilePublic: false,
  loading: false,
  text: 'Aguarde Processando...',
  dark: false,
  classes: null,
  background: null,
  customLoader: null,
  noSchedule: false
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/gadget/resources/data.js